import { DatePipe } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

import { NumberCommaPipe, PercentageValuePipe, RoundValuePipe, TranslateTokenPipe } from "../../../../core/pipes";
import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import {
  AdaaBoolean,
  EmployeePulseUploadStatus,
  ImportExportStatus,
  ImportExportType,
  ItemStatusDs3,
  PublishedState,
} from "../../../constants/enums";
import { ParameterCatalog } from "../../../models";
import { FilesApiService } from "../../../services";

@Component({
  selector: "adaa-data-table-cell-special",
  templateUrl: "./data-table-cell-special.html",
  styleUrl: "./data-table-cell-special.scss",
  imports: [TranslatePipe, RoundValuePipe, PercentageValuePipe, TranslateTokenPipe, DatePipe, NumberCommaPipe],
})
export class DataTableCellSpecialComponent {
  readonly filesApiService = inject(FilesApiService);
  private readonly _route = inject(ActivatedRoute);

  configKey = input.required<string>();
  column = input.required<ParameterCatalog>();
  data = input.required<{
    [k: string]: unknown;
  }>();

  readonly PublishedState = PublishedState;
  readonly ImportExportStatus = ImportExportStatus;
  readonly ImportExportType = ImportExportType;
  readonly EmployeePulseUploadStatus = EmployeePulseUploadStatus;
  readonly Constants = Constants;
  readonly AdaaHelper = AdaaHelper;
  readonly AdaaBoolean = AdaaBoolean;

  readonly isActivitiesViewPage = () => this._route.component?.name === "_ActivitiesViewComponent";

  public get statusLabel() {
    const status = this.data()?.projectStatus as ItemStatusDs3;

    if (!status) return undefined;

    const color = Constants.ITEM_DS3_STATUS_COLOR_CODES[status];

    return {
      label: `initiatives.project_status.${status.toLocaleLowerCase()}`,
      color: color,
    };
  }

  public isCommentEmpty(data: { [k: string]: unknown }) {
    if (!data?.comments) return true;
    return !AdaaHelper.isDefinedAndNotEmpty((data.comments as string).trim());
  }

  public getNumberValue(fieldName: string) {
    return this.data()[fieldName] as number;
  }

  public getArrayValue(fieldName: string) {
    return this.data()[fieldName] as { categoryNameAE: string; categoryNameEN: string; comments: string; id: number }[];
  }
}
